import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "select_user" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "pie2_admin" }
const _hoisted_4 = { class: "pie_admin_el" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", {
  class: "pie_title",
  style: {"padding-left":"30px"}
}, "Всего заявлений", -1)
const _hoisted_6 = { class: "pie_admin_num1" }
const _hoisted_7 = { class: "pie_admin_el" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "pie_title" }, "Всего доверенностей", -1)
const _hoisted_9 = { class: "pie_admin_num2" }
const _hoisted_10 = { class: "user_list" }
const _hoisted_11 = { class: "user_list_table" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("tr", { class: "user_list_head" }, [
  /*#__PURE__*/_createElementVNode("td", null, "Пользователь"),
  /*#__PURE__*/_createElementVNode("td", null, "Заявления"),
  /*#__PURE__*/_createElementVNode("td", null, "Доверенности")
], -1)
const _hoisted_13 = { class: "user_list_content" }
const _hoisted_14 = { class: "users_signs" }
const _hoisted_15 = { class: "users_block" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "users_block_title" }, "Посетителей всего/сегодня", -1)
const _hoisted_17 = { class: "users_block_all" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "users_slash" }, "/", -1)
const _hoisted_19 = { class: "users_block_today" }
const _hoisted_20 = { class: "signs_block" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "signs_block_title" }, "Добавлено подписантов всего/сегодня", -1)
const _hoisted_22 = { class: "signs_block_all" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "signs_slash" }, "/", -1)
const _hoisted_24 = { class: "signs_block_today" }
const _hoisted_25 = {
  class: "calendar",
  style: {"height":"406px !important"}
}
const _hoisted_26 = { class: "new_action" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "new_action_title" }, "Новых действий сегодня", -1)
const _hoisted_28 = {
  key: 0,
  class: "new_action_num"
}
const _hoisted_29 = {
  key: 1,
  class: "new_action_num"
}
const _hoisted_30 = {
  key: 2,
  class: "new_action_table"
}
const _hoisted_31 = { class: "new_action_head" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("tr", { class: "new_action_content" }, [
  /*#__PURE__*/_createElementVNode("td", null, "Завершённые заявления"),
  /*#__PURE__*/_createElementVNode("td", null, "Незавершённые заявления"),
  /*#__PURE__*/_createElementVNode("td", null, "Новые доверенности"),
  /*#__PURE__*/_createElementVNode("td", null, "Новые подписанты")
], -1)
const _hoisted_33 = { key: 1 }
const _hoisted_34 = { class: "pie2" }
const _hoisted_35 = { class: "pie_el" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("div", {
  class: "pie_title",
  style: {"padding-left":"30px"}
}, "Всего заявлений", -1)
const _hoisted_37 = { class: "pie_num1" }
const _hoisted_38 = { class: "pie_el" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("div", { class: "pie_title" }, "Всего доверенностей", -1)
const _hoisted_40 = { class: "pie_num2" }
const _hoisted_41 = { class: "calendar" }
const _hoisted_42 = { class: "area1" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("div", { class: "area_title" }, "Активность в текущем месяце", -1)
const _hoisted_44 = { class: "area_num" }
const _hoisted_45 = { class: "new_action" }
const _hoisted_46 = /*#__PURE__*/_createElementVNode("div", { class: "new_action_title" }, "Новых действий сегодня", -1)
const _hoisted_47 = {
  key: 0,
  class: "new_action_num"
}
const _hoisted_48 = {
  key: 1,
  class: "new_action_num"
}
const _hoisted_49 = {
  key: 2,
  class: "new_action_table"
}
const _hoisted_50 = { class: "new_action_head" }
const _hoisted_51 = /*#__PURE__*/_createElementVNode("tr", { class: "new_action_content" }, [
  /*#__PURE__*/_createElementVNode("td", null, "Завершённые заявления"),
  /*#__PURE__*/_createElementVNode("td", null, "Незавершённые заявления"),
  /*#__PURE__*/_createElementVNode("td", null, "Новые доверенности"),
  /*#__PURE__*/_createElementVNode("td", null, "Новые подписанты")
], -1)
const _hoisted_52 = { class: "pie2" }
const _hoisted_53 = { class: "pie_el" }
const _hoisted_54 = /*#__PURE__*/_createElementVNode("div", {
  class: "pie_title",
  style: {"padding-left":"30px"}
}, "Всего заявлений", -1)
const _hoisted_55 = { class: "pie_num1" }
const _hoisted_56 = { class: "pie_el" }
const _hoisted_57 = /*#__PURE__*/_createElementVNode("div", { class: "pie_title" }, "Всего доверенностей", -1)
const _hoisted_58 = { class: "pie_num2" }
const _hoisted_59 = { class: "calendar" }
const _hoisted_60 = { class: "area1" }
const _hoisted_61 = /*#__PURE__*/_createElementVNode("div", { class: "area_title" }, "Активность в текущем месяце", -1)
const _hoisted_62 = { class: "area_num" }
const _hoisted_63 = { class: "new_action" }
const _hoisted_64 = /*#__PURE__*/_createElementVNode("div", { class: "new_action_title" }, "Новых действий сегодня", -1)
const _hoisted_65 = {
  key: 0,
  class: "new_action_num"
}
const _hoisted_66 = {
  key: 1,
  class: "new_action_num"
}
const _hoisted_67 = {
  key: 2,
  class: "new_action_table"
}
const _hoisted_68 = { class: "new_action_head" }
const _hoisted_69 = /*#__PURE__*/_createElementVNode("tr", { class: "new_action_content" }, [
  /*#__PURE__*/_createElementVNode("td", null, "Завершённые заявления"),
  /*#__PURE__*/_createElementVNode("td", null, "Незавершённые заявления"),
  /*#__PURE__*/_createElementVNode("td", null, "Новые доверенности"),
  /*#__PURE__*/_createElementVNode("td", null, "Новые подписанты")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_GChart = _resolveComponent("GChart")!
  const _component_VCalendar = _resolveComponent("VCalendar")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.stat.statuser==0)
      ? (_openBlock(), _createElementBlock("div", {
          key: _ctx.stat.statuser_key
        }))
      : _createCommentVNode("", true),
    (_ctx.stat.statuser==2)
      ? (_openBlock(), _createElementBlock("div", {
          key: _ctx.stat.statuser_key
        }, [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_Dropdown, {
              modelValue: _ctx.client_name_title,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.client_name_title) = $event)),
              editable: "",
              options: _ctx.client_name_options,
              optionLabel: "name",
              placeholder: _ctx.client_name_default.name,
              onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.client_name_change($event))),
              style: {"width":"494px","margin-left":"20px","margin-top":"20px"}
            }, null, 8, ["modelValue", "options", "placeholder"])
          ]),
          (_ctx.stat.statuser==2 && _ctx.client_id=='0')
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, [
                    _hoisted_5,
                    _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.stat.statements_all), 1),
                    (_ctx.stat.statements_pie.length>1)
                      ? (_openBlock(), _createBlock(_component_GChart, {
                          type: "PieChart",
                          data: _ctx.stat.statements_pie,
                          options: _ctx.pie1Options_admin,
                          key: _ctx.stat.statements_key
                        }, null, 8, ["data", "options"]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_7, [
                    _hoisted_8,
                    _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.stat.declarations_all), 1),
                    (_ctx.stat.declarations_pie.length>1)
                      ? (_openBlock(), _createBlock(_component_GChart, {
                          type: "PieChart",
                          data: _ctx.stat.declarations_pie,
                          options: _ctx.pie2Options_admin,
                          key: _ctx.stat.declarations_key
                        }, null, 8, ["data", "options"]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("table", _hoisted_11, [
                      _hoisted_12,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stat.info_arr, (item) => {
                        return (_openBlock(), _createElementBlock("tr", _hoisted_13, [
                          _createElementVNode("td", null, _toDisplayString(item[0]), 1),
                          _createElementVNode("td", null, _toDisplayString(item[1]), 1),
                          _createElementVNode("td", null, _toDisplayString(item[2]), 1)
                        ]))
                      }), 256))
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    _hoisted_16,
                    _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.stat.users_all), 1),
                    _hoisted_18,
                    _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.stat.users_today), 1)
                  ]),
                  _createElementVNode("div", _hoisted_20, [
                    _hoisted_21,
                    _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.stat.signs_all), 1),
                    _hoisted_23,
                    _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.stat.signs_today), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_25, [
                  _withDirectives(_createElementVNode("input", {
                    class: "date_el",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.firstDay_admin) = $event)),
                    type: "date",
                    onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.get_stat && _ctx.get_stat(...args)))
                  }, null, 544), [
                    [_vModelText, _ctx.firstDay_admin]
                  ]),
                  _withDirectives(_createElementVNode("input", {
                    class: "date_el",
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.lastDay_admin) = $event)),
                    style: {"margin-left":"7px"},
                    type: "date",
                    onChange: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.get_stat && _ctx.get_stat(...args)))
                  }, null, 544), [
                    [_vModelText, _ctx.lastDay_admin]
                  ]),
                  _createVNode(_component_VCalendar, {
                    style: {"width":"328px","height":"341px","margin-top":"7px","border":"none","border-radius":"2px"},
                    onDayclick: _ctx.change_modal_cal_admin
                  }, null, 8, ["onDayclick"])
                ]),
                _createElementVNode("div", _hoisted_26, [
                  _hoisted_27,
                  (_ctx.stat.actions_day_all!=0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_28, _toDisplayString(_ctx.stat.actions_day_all), 1))
                    : _createCommentVNode("", true),
                  (_ctx.stat.actions_day_all==0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_29, "Новых действий произведено не было"))
                    : _createCommentVNode("", true),
                  (_ctx.stat.actions_day_all!=0)
                    ? (_openBlock(), _createElementBlock("table", _hoisted_30, [
                        _createElementVNode("tr", _hoisted_31, [
                          _createElementVNode("td", null, _toDisplayString(_ctx.stat.statements_day_print), 1),
                          _createElementVNode("td", null, _toDisplayString(_ctx.stat.statements_day_noprint), 1),
                          _createElementVNode("td", null, _toDisplayString(_ctx.stat.declarations_day_all), 1),
                          _createElementVNode("td", null, _toDisplayString(_ctx.stat.signatories_day_all), 1)
                        ]),
                        _hoisted_32
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.stat.statuser==2 && _ctx.client_id!='0')
            ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                _createElementVNode("div", _hoisted_34, [
                  _createElementVNode("div", _hoisted_35, [
                    _hoisted_36,
                    _createElementVNode("div", _hoisted_37, _toDisplayString(_ctx.stat.statements_all), 1),
                    (_ctx.stat.statements_pie.length>1)
                      ? (_openBlock(), _createBlock(_component_GChart, {
                          type: "PieChart",
                          data: _ctx.stat.statements_pie,
                          options: _ctx.pie1Options,
                          key: _ctx.stat.statements_key
                        }, null, 8, ["data", "options"]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_38, [
                    _hoisted_39,
                    _createElementVNode("div", _hoisted_40, _toDisplayString(_ctx.stat.declarations_all), 1),
                    (_ctx.stat.declarations_pie.length>1)
                      ? (_openBlock(), _createBlock(_component_GChart, {
                          type: "PieChart",
                          data: _ctx.stat.declarations_pie,
                          options: _ctx.pie2Options,
                          key: _ctx.stat.declarations_key
                        }, null, 8, ["data", "options"]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_41, [
                  _withDirectives(_createElementVNode("input", {
                    class: "date_el",
                    type: "date",
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.firstDay) = $event)),
                    onChange: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.get_stat && _ctx.get_stat(...args)))
                  }, null, 544), [
                    [_vModelText, _ctx.firstDay]
                  ]),
                  _withDirectives(_createElementVNode("input", {
                    class: "date_el",
                    style: {"margin-left":"7px"},
                    type: "date",
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.lastDay) = $event)),
                    onChange: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.get_stat && _ctx.get_stat(...args)))
                  }, null, 544), [
                    [_vModelText, _ctx.lastDay]
                  ]),
                  _createVNode(_component_VCalendar, {
                    style: {"width":"328px","height":"378px","margin-top":"7px","border":"none","border-radius":"2px"},
                    onDayclick: _ctx.change_modal_cal
                  }, null, 8, ["onDayclick"])
                ]),
                _createElementVNode("div", _hoisted_42, [
                  _hoisted_43,
                  _createElementVNode("div", _hoisted_44, _toDisplayString(_ctx.stat.areachart_all), 1),
                  (_openBlock(), _createBlock(_component_GChart, {
                    type: "AreaChart",
                    data: _ctx.stat.areachart,
                    options: _ctx.chartOptions,
                    key: _ctx.stat.areachart_key
                  }, null, 8, ["data", "options"]))
                ]),
                _createElementVNode("div", _hoisted_45, [
                  _hoisted_46,
                  (_ctx.stat.actions_day_all!=0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_47, _toDisplayString(_ctx.stat.actions_day_all), 1))
                    : _createCommentVNode("", true),
                  (_ctx.stat.actions_day_all==0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_48, "Новых действий произведено не было"))
                    : _createCommentVNode("", true),
                  (_ctx.stat.actions_day_all!=0)
                    ? (_openBlock(), _createElementBlock("table", _hoisted_49, [
                        _createElementVNode("tr", _hoisted_50, [
                          _createElementVNode("td", null, _toDisplayString(_ctx.stat.statements_day_print), 1),
                          _createElementVNode("td", null, _toDisplayString(_ctx.stat.statements_day_noprint), 1),
                          _createElementVNode("td", null, _toDisplayString(_ctx.stat.declarations_day_all), 1),
                          _createElementVNode("td", null, _toDisplayString(_ctx.stat.signatories_day_all), 1)
                        ]),
                        _hoisted_51
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_ctx.stat.statuser==1)
      ? (_openBlock(), _createElementBlock("div", {
          key: _ctx.stat.statuser_key
        }, [
          _createElementVNode("div", _hoisted_52, [
            _createElementVNode("div", _hoisted_53, [
              _hoisted_54,
              _createElementVNode("div", _hoisted_55, _toDisplayString(_ctx.stat.statements_all), 1),
              (_ctx.stat.statements_pie.length>1)
                ? (_openBlock(), _createBlock(_component_GChart, {
                    type: "PieChart",
                    data: _ctx.stat.statements_pie,
                    options: _ctx.pie1Options,
                    key: _ctx.stat.statements_key
                  }, null, 8, ["data", "options"]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_56, [
              _hoisted_57,
              _createElementVNode("div", _hoisted_58, _toDisplayString(_ctx.stat.declarations_all), 1),
              (_ctx.stat.declarations_pie.length>1)
                ? (_openBlock(), _createBlock(_component_GChart, {
                    type: "PieChart",
                    data: _ctx.stat.declarations_pie,
                    options: _ctx.pie2Options,
                    key: _ctx.stat.declarations_key
                  }, null, 8, ["data", "options"]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_59, [
            _withDirectives(_createElementVNode("input", {
              class: "date_el",
              type: "date",
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.firstDay) = $event)),
              onChange: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.get_stat && _ctx.get_stat(...args)))
            }, null, 544), [
              [_vModelText, _ctx.firstDay]
            ]),
            _withDirectives(_createElementVNode("input", {
              class: "date_el",
              style: {"margin-left":"7px"},
              type: "date",
              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.lastDay) = $event)),
              onChange: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.get_stat && _ctx.get_stat(...args)))
            }, null, 544), [
              [_vModelText, _ctx.lastDay]
            ]),
            _createVNode(_component_VCalendar, {
              style: {"width":"328px","height":"378px","margin-top":"7px","border":"none","border-radius":"2px"},
              onDayclick: _ctx.change_modal_cal
            }, null, 8, ["onDayclick"])
          ]),
          _createElementVNode("div", _hoisted_60, [
            _hoisted_61,
            _createElementVNode("div", _hoisted_62, _toDisplayString(_ctx.stat.areachart_all), 1),
            (_openBlock(), _createBlock(_component_GChart, {
              type: "AreaChart",
              data: _ctx.stat.areachart,
              options: _ctx.chartOptions,
              key: _ctx.stat.areachart_key
            }, null, 8, ["data", "options"]))
          ]),
          _createElementVNode("div", _hoisted_63, [
            _hoisted_64,
            (_ctx.stat.actions_day_all!=0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_65, _toDisplayString(_ctx.stat.actions_day_all), 1))
              : _createCommentVNode("", true),
            (_ctx.stat.actions_day_all==0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_66, "Новых действий произведено не было"))
              : _createCommentVNode("", true),
            (_ctx.stat.actions_day_all!=0)
              ? (_openBlock(), _createElementBlock("table", _hoisted_67, [
                  _createElementVNode("tr", _hoisted_68, [
                    _createElementVNode("td", null, _toDisplayString(_ctx.stat.statements_day_print), 1),
                    _createElementVNode("td", null, _toDisplayString(_ctx.stat.statements_day_noprint), 1),
                    _createElementVNode("td", null, _toDisplayString(_ctx.stat.declarations_day_all), 1),
                    _createElementVNode("td", null, _toDisplayString(_ctx.stat.signatories_day_all), 1)
                  ]),
                  _hoisted_69
                ]))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}